import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=5a440b4a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a440b4a",
  null
  
)

export default component.exports